/****************************************************************************************
 * Responsibility - Validates the min and max values of a roll diameter.
 *
 * TODO: Make this the only source of truth for all fields that allow roll diameter input.
 */

import { MAXIMUM_ROLL_DIAMETER, NARROW_LABEL_MAX_ROLL_DIAMETER, NARROW_LABEL_WIDTH_THRESHOLD, PRODUCT_TYPE_LABEL } from 'frontier-constants';

export function isNarrowLabel(width, productTypeId = null) {
    // Only apply to labels, not cartons
    if (productTypeId && productTypeId !== PRODUCT_TYPE_LABEL) {
        return false;
    }
    return width && !isNaN(parseFloat(width)) && parseFloat(width) > 0 && parseFloat(width) < NARROW_LABEL_WIDTH_THRESHOLD;
}

export function getMaxRollDiameterForWidth(width, productTypeId = null) {
    return isNarrowLabel(width, productTypeId) ? NARROW_LABEL_MAX_ROLL_DIAMETER : MAXIMUM_ROLL_DIAMETER;
}

export function handleRollManMixValidation (value, field, width = null) {
    if(!isNaN(value)) {
        if (value <= 0) {
            return {error: 'Value must be greater than 0'};
        }

        const maxDiameter = width ? getMaxRollDiameterForWidth(width) : MAXIMUM_ROLL_DIAMETER;

        if (value > maxDiameter) {
            if (isNarrowLabel(width)) {
                return {error: `Labels under ${NARROW_LABEL_WIDTH_THRESHOLD}" wide are limited to ${NARROW_LABEL_MAX_ROLL_DIAMETER}" diameter rolls`};
            }
            return {error: `Value cannot be greater than ${maxDiameter}"`};
        }
    }

    return value
};
